import { getEnvVar } from '@psyomics/ui-common';

export type Config = {
  clinicianApiUrl: string;
  clinicianApiCognitoDomain: string;
  sentryDsn: string;
  environment: string;
  postHogApiKey: string;
  postHogHost: string;
};

export const getConfig = (): Config => {
  const clinicianApiUrl = getEnvVar('VITE_CLINICIAN_API_URL');
  const clinicianApiCognitoDomain = getEnvVar('VITE_CLINICIAN_API_COGNITO_DOMAIN');
  const sentryDsn = getEnvVar('VITE_CLINICIAN_PORTAL_SENTRY_DSN');
  const environment = getEnvVar('VITE_ENVIRONMENT');
  const postHogApiKey = getEnvVar('VITE_POSTHOG_API_KEY');
  const postHogHost = getEnvVar('VITE_POSTHOG_HOST');

  return {
    clinicianApiCognitoDomain,
    clinicianApiUrl,
    environment,
    postHogApiKey,
    postHogHost,
    sentryDsn,
  };
};
